import React from "react";

type SwitchCompProps = {
  resumeType: boolean[];
  setResumeType: (newArray: boolean[]) => void;
  index: number;
  on: string;
  off: string;
};

const SwitchComp: React.FC<SwitchCompProps> = ({
  resumeType,
  setResumeType,
  index,
  on,
  off,
}) => {
  const isOn = resumeType[index];

  const handleToggle = () => {
    const newArray = [...resumeType];
    newArray[index] = !resumeType[index];
    setResumeType(newArray);
  };

  return (
    <div className="flex items-center gap-2">
      <span className={`text-xs font-medium transition-colors ${isOn ? "text-gray-600" : "text-gray-500"}`}>
        {off}
      </span>

      <button
        role="switch"
        aria-checked={isOn}
        onClick={handleToggle}
        className={`
          relative inline-flex h-5 w-9 items-center rounded-full transition-all duration-300
          outline-none 
          ${isOn ? "bg-blue-500" : "bg-gray-300"}
        `}
      >
        {/* Track */}
        <span className="sr-only">
          {isOn ? on : off}
        </span>

        {/* Thumb */}
        <span
          className={`
            inline-block h-3 w-3 transform rounded-full bg-white shadow-lg transition-all duration-300
            ${isOn ? "translate-x-5" : "translate-x-1"}
          `}
        />
      </button>

      <span className={`text-xs font-medium transition-colors ${isOn ? "text-blue-600" : "text-gray-600"}`}>
        {on}
      </span>
    </div>
  );
};

export default SwitchComp;